import React, { useEffect, useRef, useState } from "react";
import { useSearch } from "./SearchContext";
import { GoogleMap, Marker, LoadScript, GoogleMapProps, MarkerProps, MarkerClusterer, MarkerClustererProps } from "@react-google-maps/api";
import { IListing } from "../../lib";
import { InfoMarker } from "./InfoMarker";

export interface IMapProps {
  zoom?: number;
  className?: string;
  renderItemMarkerWindow?: (arg0: any) => React.ReactNode;
  renderItemMarker?: (arg0: any) => React.ReactNode;
  mapId?: string;
  mapApiKey?: string;
  mapClick?: (arg: any) => void;
  extraLocations?: IListing[];
  mapProps?: Partial<GoogleMapProps>;
  markerProps?: Partial<MarkerProps>;
  useSimpleMarker?: boolean;
  markerClustererProps?: Partial<MarkerClustererProps>;
}

export const Map: React.FC<IMapProps> = ({
  children,
  className,
  zoom = 12,
  renderItemMarker,
  renderItemMarkerWindow,
  mapClick,
  mapApiKey = "AIzaSyBSypNhQTAdXM5ua2lx93n2Cwso-Rgra4w",
  mapId,
  extraLocations,
  mapProps,
  markerProps,
  useSimpleMarker = false,
  markerClustererProps,
}) => {
  const [gmap, setGMap] = useState<google.maps.Map | null>(null);

  const searchContext = useSearch();

  const items = searchContext.currentResults;

  let mapable = items.filter((item) => {
    return (item.location && item.location.lat && item.location.lng) && !item.hideOnMap;
  });

  if (extraLocations && extraLocations.length > 0) {
    extraLocations.forEach(location => {
      mapable.push(location)
    })
  }

  useEffect(() => {
    if (gmap) {
      let bounds = new google.maps.LatLngBounds();
      mapable.map((item) => {
        bounds.extend(item.location);
      });
      gmap.fitBounds(bounds, 20);
      (gmap.getZoom() || 0) > 15 && gmap.setZoom(15);
      gmap.panBy(0, -1);
    }
  }, [mapable, gmap]);

  const clusterDefault = [
    {
      textColor: 'white',
      height: 28,
      width: 28,
      className: "rounded-full bg-[#C19B5F] hover:bg-[#0A275D] drop-shadow-md",
      url: "https://cdn.aglty.io/anne-erwin-sir/commons/hidden.png"
    },
  ]

  const clustererOptions = {
    styles: clusterDefault,
    ignoreHidden: true,
  }

  return (
    <div className={`search-map ${className}`}>
      <LoadScript googleMapsApiKey={mapApiKey}>
        <GoogleMap
          mapContainerStyle={{
            width: "100%",
            height: "60vh",
          }}
          zoom={zoom}
          options={{ mapId: mapId, clickableIcons: false }}
          onLoad={(map) => {
            setGMap(map);
          }}
          {...mapProps}
        >
          <MarkerClusterer
            options={clustererOptions}
            maxZoom={15}
            {...markerClustererProps}
          >
            {(clusterer) =>
              mapable.map((item, index) => {
                if (item.location) {
                  if (!useSimpleMarker) {
                    return (
                      <InfoMarker
                        listingProps={item}
                        mapClick={mapClick}
                        clusterer={clusterer}
                        {...markerProps}
                      />
                    )
                  }
                  else {
                    return (<Marker
                      position={item.location}
                      title={item.address?.text}
                      key={index}
                      onClick={(event) => mapClick && mapClick(item)}
                      clusterer={clusterer}
                      {...markerProps}
                    />)
                  }
                }
              })
            }
          </MarkerClusterer>

          {children}
        </GoogleMap>
      </LoadScript>
    </div>
  );
};
